export default "__VITE_ASSET__d3318888__"